import React from "react";
import { Pagination } from "@mui/material";

const CustomPagination = ({
  totalPages,
  currentPage,
  onPageChange,
  showFirstButton = true,
  showLastButton = true,
  color = "primary",
}) => {
  // Handle edge cases
  if (totalPages <= 0) {
    return null; // Don't render pagination if no pages
  }

  // Determine if we should disable previous/next buttons
  const isOnlyOnePage = totalPages === 1;
  const isFirstPage = currentPage === 1;
  const isLastPage = currentPage === totalPages;

  return (
    <div className="fn-pagination-wrapper">
      <Pagination
        count={totalPages}
        page={currentPage}
        onChange={(event, value) => onPageChange(value)}
        color={color}
        // Disable previous button on first page or when only one page
        hidePrevButton={isFirstPage || isOnlyOnePage}
        // Disable next button on last page or when only one page
        hideNextButton={isLastPage || isOnlyOnePage}
        // Show/hide first/last buttons based on props and conditions
        showFirstButton={showFirstButton && !isOnlyOnePage}
        showLastButton={showLastButton && !isOnlyOnePage}
        sx={{
          "& .MuiPaginationItem-root": {
            backgroundColor: "#ffffff",
            color: "#6b7280",
            border: "1px solid #e5e7eb",
            borderRadius: "20px",
            "&:hover": {
              backgroundColor: "#f9fafb",
              borderColor: "#d1d5db",
            },
            // Disable styles for navigation buttons
            "&.Mui-disabled": {
              backgroundColor: "#f3f4f6",
              color: "#9ca3af",
              border: "1px solid #e5e7eb",
              cursor: "not-allowed",
            },
          },
          "& .Mui-selected": {
            backgroundColor: "#667eea",
            color: "#ffffff",
            border: "1px solid #667eea",
            "&:hover": {
              backgroundColor: "#5a52d5",
            },
          },
          // Hide pagination completely if only one page (alternative approach)
          ...(isOnlyOnePage && { display: "none" }),
        }}
      />
    </div>
  );
};

export default CustomPagination;
